import {Graph, Node, Cluster} from "./index";
import {TrainingsGridData} from "components/calendar/model/TrainingsGridData";

//Решение было создано на основе алгоритма описанного тут https://github.com/vlio20/one-day
export class TrainingsGraphCalculator {

    static getGraph = function(trainingsRange, time) {

        // Строим гистограмму тренировок разбитых по временным отрезкам. Иными словами строим массив
        // массивов, где внешний массив это отрезки времени, в которые входят тренировки, а
        // внутренний массив это список пересекающих это время тренировок
        const createHistogram = function (times, events) {
            const hoursCountInOneDay = 24;
            const minutesCountInOneHour = 60;

            let histogram = new Array(hoursCountInOneDay * minutesCountInOneHour);
            for (let i = 0; i < histogram.length; i++) {
                histogram[i] = [];
            }

            events.forEach((y, yIndex) => {
                let startTime = y.startTime.hours() * minutesCountInOneHour + y.startTime.minutes();
                let endTime = y.endTime.hours() * minutesCountInOneHour + y.endTime.minutes();
                for (let i = startTime; i <= endTime - 1; i++) {
                    histogram[i].push(y.id);
                }
            })

            return histogram;
        };

        //Создаём граф (Graph), представляющий собой сущность хранящуюю массив кластеров (Cluster),
        //которые являются сущностями, которые хранят информацию о пересекающихся событиях (Nodes).
        const createGraph = function (events, histogram) {
            let graph = new Graph();
            let nodeMap = {};

            events.forEach(function (event) {
                let node = new Node(event.id, event.range, event.data, event.date,
                    event.startTime, event.endTime);
                nodeMap[node.id] = node;
            });

            let cluster = null;

            histogram.forEach(histogramItem => {
                if (histogramItem.length > 0) {
                    cluster = cluster || new Cluster();
                    histogramItem.forEach(item => {
                        if (!cluster.nodes[item]) {
                            cluster.nodes[item] = nodeMap[item];

                            nodeMap[item].cluster = cluster;
                        }
                    })
                } else {
                    if (cluster !== null) {
                        graph.clusters.push(cluster);
                    }
                    cluster = null;
                }
            });

            if (cluster !== null) {
                graph.clusters.push(cluster);
            }

            histogram.forEach(histogramItem => {
                histogramItem.forEach(item => {
                    let sourceNode = nodeMap[item];

                    sourceNode.biggestCliqueSize = Math.max(sourceNode.biggestCliqueSize,
                        histogramItem.length);

                    histogramItem.forEach(targetId => {
                        if (item !== targetId) {
                            sourceNode.neighbours[targetId] = nodeMap[targetId];
                        }
                    });
                });
            });

            graph.clusters.forEach(cluster => {
                let maxClique = 1;

                Object.keys(cluster.nodes).forEach(nodeId => {
                   let node = cluster.nodes[nodeId];
                   maxClique = Math.max(node.biggestCliqueSize, maxClique);
               });

               Object.keys(cluster.nodes).forEach(nodeId => {
                   cluster.nodes[nodeId].biggestCliqueSize = maxClique;
               });
            });

            graph.nodes = nodeMap;

            return graph;
        };

        //Рассчёт ширины кластера (кол-ва событий, пересекающихся в определённое время)
        const  setClusterWidth = function(graph) {
            graph.clusters.forEach(cluster => {
                let maxCliqueSize = 1;

                for (let nodeId in cluster.nodes) {
                    maxCliqueSize = Math.max(maxCliqueSize, cluster.nodes[nodeId].biggestCliqueSize);
                }
                cluster.maxCliqueSize = maxCliqueSize;
            });
        };

        //Рассчёт позиций элемента в сетке по горизонтали.
        const setNodesPosition = function (graph) {
            graph.clusters.forEach(cluster => {
                for (let nodeId in cluster.nodes) {
                    let node = cluster.nodes[nodeId];
                    let positionArray = new Array(node.cluster.maxCliqueSize);

                    for (let neighbourId in node.neighbours) {
                        let neighbour = node.neighbours[neighbourId];
                        if (neighbour.position != null) {
                            positionArray[neighbour.position] = true;
                        }
                    }

                    for (let i = 0; i < positionArray.length; i++) {
                        if (!positionArray[i]) {
                            node.position = i;
                            break;
                        }
                    }
                }
            })
        };

        if (trainingsRange === null) return [];

        let times = time.map((x, index) => ({
            id: index + 1,
            value: x
        }));

        var result = [];

        trainingsRange.forEach(dayData => {
            let trainingRanges = dayData.trainings
                .map((x, index) => ({
                    id: index + 1,
                    range: x.trainingsRange,
                    data: x.trainingsData,
                    date: x.trainingsDate,
                    startTime: x.trainingStartTime,
                    endTime: x.trainingEndTime
            }));

            let histogram = createHistogram(times, trainingRanges);
            let graph = createGraph(trainingRanges, histogram);
            setClusterWidth(graph);
            setNodesPosition(graph);

            let trainingsGridData = [];

            for (let noteId in graph.nodes){
                let note = graph.nodes[noteId];
                trainingsGridData.push(new TrainingsGridData(note));
            }

            result.push(
                {
                    workingDayId: dayData.workingDayId,
                    trainingsGridData: trainingsGridData
                }
            );
        });

        return result;
    };
}